import { cadastrarArquivosReserva } from "../../../services/cadastrarArquivosReserva";
import { atualizarReservaService } from "../../../services/atualizarReservaService";
import dayjs from "dayjs";

export const useCadastrarArquivosReserva = (
  reservaId: number | null,
  dataAutorizacao: any
) => {
  const cadastrar = async (dataArquivo: number) => {
    const data = {
      idReserva: reservaId,
      idArquivo: dataArquivo,
    };
    const dataReserva = {
      statusReserva: "AGUARDANDO_CHECKIN",
      dataAutorizacao: dataAutorizacao
        ? dayjs(dataAutorizacao.dataAutorizacao).format("DD/MM/YYYY")
        : null,
    };
    try {
      const arquivos = await cadastrarArquivosReserva(data);

      if (arquivos) {
        const atualizarReserva = await atualizarReservaService(
          reservaId,
          dataReserva
        );
        if (atualizarReserva) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  return { cadastrar };
};
